
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Urbaniatouristbusonrentinpune() {



  const cardData =
  {
    keyword: ' Urbania Tourist Bus on Rent in Pune',
    heading: 'Vaishnavi Travels: Urbania Tourist Bus on Rent in Pune',
    headingDescription: 'Vaishnavi Travels offers comfortable and affordable Urbania Tourist Bus on Rent in Pune, ideal for weddings, family trips, school tours, corporate outings, and outstation journeys. Our Urbania buses are well-maintained with spacious seating, powerful air-conditioning, and ample luggage space to ensure a smooth and enjoyable travel experience. With professional drivers, timely pickups, and flexible booking options, we provide stress-free transportation for both short city rides and long-distance tours. Whether it’s a religious yatra, holiday vacation, or business trip, Vaishnavi Travels guarantees safe, reliable, and convenient Urbania Tourist Bus rental services in Pune.',

    top: 'Top Places to Visit in Pune with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort palace and a proud symbol of Maratha power. Once the seat of the Maratha Empire, its massive gates, sprawling gardens, and ruins narrate tales of valor. Though partially destroyed by a fire in 1828, it still draws thousands of visitors every day. The evening light-and-sound show brings alive the love story of Bajirao and Mastani and the grandeur of the Peshwas. Its corridors, courtyards, and fountains carry echoes of Maratha history. Shaniwar Wada remains Pune’s most cherished cultural landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Built in 1892, the Aga Khan Palace is one of Pune’s most historic monuments linked to India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. Today, the palace houses a museum displaying Gandhi’s personal belongings, letters, and photographs. Its Italian arches and sprawling gardens add architectural charm and peaceful vibes. Tourists enjoy strolling through its lawns while reflecting on history. Aga Khan Palace is Pune’s inspirational symbol of patriotism and sacrifice."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is a legendary hill fort known for the 1670 battle where Tanaji Malusare fought valiantly for Chhatrapati Shivaji Maharaj. Perched atop a hill, it offers breathtaking panoramic views of the Sahyadris and trekking trails loved by adventurers. The fort still houses bastions, memorials, and temples that narrate Maratha bravery. During monsoon, mist and waterfalls enhance its charm. Visitors also relish rustic delicacies like pithla-bhakri at local stalls. Sinhagad Fort is Pune’s perfect blend of history, nature, and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. Established over 125 years ago, it houses a magnificent idol adorned with gold and ornaments. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities attracting lakhs of devotees. Known for its charitable and cultural initiatives, it serves as both a spiritual and social hub. The temple’s vibrant aura captivates tourists and locals alike. Dagdusheth Ganpati Temple is Pune’s divine and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "The Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. It features massive stone pillars, sanctum chambers, and a Nandi mandapa. Despite being in the city center, it offers peace and meditation amidst the chaos. Evening prayers and chants add to its mystical ambiance. The temple reflects ancient Indian craftsmanship and architectural skill. Pataleshwar Cave Temple is Pune’s hidden gem of spiritual heritage."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum is a cultural treasure housing over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include musical instruments, ornaments, sculptures, and everyday antiques. A highlight is the recreated Mastani Mahal, reflecting the romance of Maratha history. Students and history enthusiasts find it deeply educational and fascinating. The museum preserves centuries of traditions and artistry under one roof. Raja Dinkar Kelkar Museum is Pune’s proud showcase of culture and heritage."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest heritage landmarks, offers panoramic views of the city from its temple complex. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller temples and a museum add depth to the visit. Pilgrims and tourists climb 103 steps to reach the top, combining devotion with scenic beauty. Sunrise and sunset views from here are mesmerizing. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global hub for wellness, spirituality, and mindfulness. Spread across lush gardens, it attracts seekers and tourists from all over the world. The ashram offers meditation sessions, yoga practices, and personal growth workshops. Its Japanese Zen gardens and tranquil halls enhance the experience. Beyond spirituality, it is also a retreat for relaxation and rejuvenation. Osho Ashram is Pune’s international center of peace and healing."
  },
  {
    "title": "Pu La Deshpande Garden (Okayama Friendship Garden)",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. With flowing streams, stone bridges, and manicured lawns, it is a paradise for nature lovers. Families enjoy picnics, photography, and peaceful walks here. The garden symbolizes Indo-Japanese friendship and cultural exchange. Seasonal flowers add color and charm throughout the year. Pu La Deshpande Garden is Pune’s green paradise of calm and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is Pune’s popular weekend getaway. It supplies water to the city while offering scenic backdrops of hills and flowing waters. During monsoon, the overflowing dam creates spectacular views. Families enjoy roadside snacks like roasted corn and tea by the banks. It also serves as the gateway to Sinhagad Fort nearby. Khadakwasla Dam is Pune’s refreshing natural retreat for relaxation and leisure."
  }
],

"services": [
  {
    "name": "Urbania Travel Bus Pune",
    "description": "Experience top-tier travel with our Urbania travel bus service in Pune, ideal for small to mid-size groups planning both local and long-distance tours. Our Urbania vans combine modern design, plush interiors, and strong on-road performance, ensuring your journey is not just comfortable but memorable. Equipped with essential amenities such as pushback seats, large windows, and ample legroom, these vehicles are best suited for city tours, weekend retreats, and temple visits. Each rental includes an experienced driver familiar with key travel routes and safety protocols."
  },
  {
    "name": "Tourist Urbania Hire Pune",
    "description": "Hire a dedicated Tourist Urbania in Pune for your sightseeing, leisure, or pilgrimage needs. This service is tailored for families, friend groups, and small tour operators seeking luxury and reliability in one vehicle. The Urbania features air conditioning, clean upholstery, bottle holders, and smooth suspension for extended comfort. Whether it’s a day tour or multi-city travel plan, our Urbania vehicles make tourism efficient and enjoyable. Professional drivers ensure prompt arrivals at every stop, so you can focus on making memories."
  },
  {
    "name": "AC Urbania Tourist Van Pune",
    "description": "Stay cool and travel smart with our AC Urbania tourist van services in Pune. Built for comfort during long rides and hot weather conditions, these vans feature high-capacity air conditioning, tinted windows, noise insulation, and USB charging ports. Ideal for summer holidays, senior citizen groups, or long-distance religious trips, our AC vans provide a serene environment from start to finish. Daily, weekend, and extended tour packages are available with customizable pickup and drop options."
  },
  {
    "name": "13/17 Seater Tourist Urbania Pune",
    "description": "Book 13 or 17-seater Tourist Urbania vans in Pune for a convenient travel solution that suits group sizes without overpaying for unused capacity. These configurations are ideal for family outings, office retreats, school trips, or group tourism. Spacious interiors, soft-cushioned seating, and wide aisles ensure a fatigue-free journey even during longer durations. With dedicated luggage space and onboard comfort, this is the ideal choice for tailored travel experiences across Maharashtra and beyond."
  },
  {
    "name": "Pune Local Tour Urbania",
    "description": "Explore Pune’s top attractions such as Shaniwar Wada, Aga Khan Palace, Saras Baug, and more with our local tour Urbania service. Designed for city-based travel, these vans are ideal for tourists who want guided or self-paced tours across heritage sites, temples, parks, and food hubs. Our drivers are knowledgeable about local routes and tourism points, making them perfect for both residents hosting guests and out-of-towners. Choose half-day, full-day, or multi-spot tour packages at competitive rates."
  },
  {
    "name": "Urbania for Outstation Tourism",
    "description": "Take your travel outside the city with our Urbania rental service for outstation tourism. From Pune to destinations like Mahabaleshwar, Shirdi, Alibaug, or Goa, this service is suited for overnight trips, beach holidays, and pilgrimage tours. Vans are equipped with superior shock absorption, reclining seats, and power outlets, ensuring passenger comfort even on bumpy roads. Pre-trip planning, driver accommodation, and round-trip packages are available for a complete, stress-free travel experience."
  },
  {
    "name": "City Sightseeing Urbania Pune",
    "description": "Book an Urbania van for a full city sightseeing tour of Pune. This service includes structured itineraries or custom routes covering iconic spots and hidden gems. Vans come with experienced drivers who know the city’s ins and outs, reducing travel time between locations. Options include guided commentary, pre-scheduled stopovers, and refreshment breaks. Ideal for school trips, foreign tourists, and family visitors who want to make the most of their time in Pune."
  },
  {
    "name": "Pune Darshan Urbania Hire",
    "description": "Our Pune Darshan Urbania hire service is a dedicated package for those wanting to explore the cultural, spiritual, and architectural beauty of Pune in a comfortable and organized way. These Urbania vans are available in both 13 and 17-seater formats and come with courteous drivers familiar with all major darshan routes. Popular spots include Dagdusheth Ganpati, Parvati Hills, and Pataleshwar Temple. Vehicles are equipped with route maps, itinerary flexibility, and real-time support from our operations team."
  },
  {
    "name": "Long Trip Urbania Bus Pune",
    "description": "For those planning long trips from Pune—whether it’s a family tour to coastal Konkan or a pilgrimage across multiple states—our long-trip Urbania service is the perfect solution. These vans are designed for extended travel with features like adjustable seats, luggage compartments, curtains for privacy, and additional cooling vents. Our packages include tolls, state permits, and driver accommodation. Choose this option for seamless multi-day travel without the fatigue of typical road journeys."
  },
  {
    "name": "Family Tour Urbania Rental",
    "description": "Take your family on a memorable trip with our Urbania rental services in Pune. Whether it's a quick getaway or a detailed vacation, these vans are designed to cater to all age groups with clean seating, large step-ins, child-safe doors, and onboard music systems. From grandparents to toddlers, everyone travels in comfort. Enjoy customized itineraries, round-trip support, and 24/7 assistance. Perfect for festive holidays, weekend temple visits, or destination birthdays."
  },
  {
    "name": "Online Tourist Urbania Pune",
    "description": "Book your tourist Urbania van online in Pune using our user-friendly platform. With real-time availability, upfront pricing, instant confirmations, and GPS-enabled tracking, the entire booking process is seamless. Ideal for tech-savvy users who want a quick and secure way to plan travel, our portal supports special requests like extra stops, hotel pickups, and multi-day rentals. Perfect for travel agencies, tour planners, and individuals."
  },
  {
    "name": "Weekend Tourist Urbania Pune",
    "description": "Escape the city chaos with our weekend Urbania tour rentals in Pune. Head to spots like Lonavala, Bhimashankar, Lavasa, or Panchgani with a group of friends or family in a comfortable Urbania. Special weekend pricing, early morning departures, and return trip options make it an ideal choice for spontaneous or pre-planned getaways. Vans are cleaned, fueled, and ready to go by the time you board."
  },
  {
    "name": "Premium Tourist Urbania Hire",
    "description": "Travel in elite style with our premium Tourist Urbania hire service in Pune. These vans come with enhanced interiors, mood lighting, leather upholstery, bottle holders, and additional legroom. Choose this option for luxury tours, celebrity transport, or executive-level travel. Services include priority support, zero cancellation fees (with notice), and optional add-ons like refreshments, multilingual drivers, or vehicle branding. Ideal for high-end experiences or VIP guests."
  }
],
"tableData": [
  ["Urbania Travel Bus Pune", "Tourist Urbania Hire Pune"],
  ["AC Urbania Tourist Van Pune", "13/17 Seater Tourist Urbania Pune"],
  ["Pune Local Tour Urbania", "Urbania for Outstation Tourism"],
  ["City Sightseeing Urbania Pune", "Pune Darshan Urbania Hire"],
  ["Long Trip Urbania Bus Pune", "Family Tour Urbania Rental"],
  ["Online Tourist Urbania Pune", "Weekend Tourist Urbania Pune"],
  ["Premium Tourist Urbania Hire"]
],




"whychoose": [
  {
    "WhyChooseheading": "Urbania Tourist Bus on Rent in Pune",
    "WhyChoosedescription": "Vaishnavi Travels offers premium Urbania tourist buses on rent in Pune, perfect for luxury travel, city tours, corporate trips, and special occasions."
  },
  {
    "WhyChooseheading": "Luxurious and Comfortable Ride",
    "WhyChoosedescription": "Our Urbania tourist buses feature pushback seats, individual AC vents, ambient lighting, and advanced suspension for a smooth and stylish journey."
  },
  {
    "WhyChooseheading": "Clean, Safe, and Well-Maintained Vehicles",
    "WhyChoosedescription": "Each Urbania bus is thoroughly cleaned, sanitized, and maintained to deliver a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Flexible Packages for Local and Outstation Travel",
    "WhyChoosedescription": "We offer hourly, daily, and multi-day rental options for city tours, sightseeing, weekend getaways, and long-distance travel."
  },
  {
    "WhyChooseheading": "Experienced Chauffeurs for a Hassle-Free Trip",
    "WhyChoosedescription": "Our professional drivers are courteous, experienced, and well-acquainted with all major routes in and around Pune."
  },
  {
    "WhyChooseheading": "Transparent and All-Inclusive Pricing",
    "WhyChoosedescription": "No surprises — our pricing includes fuel, tolls, driver allowance, and taxes for complete peace of mind."
  },
  {
    "WhyChooseheading": "Ideal for Group Travel, Corporate Use, and VIP Guests",
    "WhyChoosedescription": "Perfect for business travel, executive transport, family functions, and group tours seeking a luxury experience."
  },
  {
    "WhyChooseheading": "24/7 Customer Support & Easy Booking",
    "WhyChoosedescription": "Get round-the-clock assistance for bookings, changes, and travel support from our dedicated customer service team."
  }
]
















  }






const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer Urbania Tourist Bus on rent in Pune?',
      answer: 'Yes, Vaishnavi Travels provides Urbania Tourist Buses on rent in Pune, perfect for group tours, sightseeing, corporate outings, and special events.',
    },
    {
      question: 'What is the seating capacity of the Urbania Tourist Bus?',
      answer: 'Our Urbania Tourist Buses typically accommodate 9 to 12 passengers, offering spacious seating with comfortable interiors designed for tourism and travel.',
    },
    {
      question: 'Are the Urbania Tourist Buses air-conditioned and well-maintained?',
      answer: 'Absolutely! All Urbania Tourist Buses in our fleet are fully air-conditioned, regularly serviced, and maintained to ensure safety, comfort, and a pleasant travel experience.',
    },
    {
      question: 'What is the approximate rental cost for an Urbania Tourist Bus in Pune?',
      answer: 'Rental costs generally start at around ₹3,500 for half-day local use. Pricing varies depending on trip duration, distance, and specific service requirements.',
    },
    {
      question: 'Are professional drivers included with the bus rental?',
      answer: 'Yes, every rental includes a professional, experienced, and courteous driver who ensures safe and smooth travel throughout your journey.',
    },
    {
      question: 'Can I book the Urbania Tourist Bus for outstation trips from Pune?',
      answer: 'Yes, we offer outstation packages for Urbania Tourist Buses including day trips and multi-day tours with clear pricing and excellent service.',
    },
    {
      question: 'How far in advance should I book the Urbania Tourist Bus?',
      answer: 'Booking at least 2-3 days in advance is recommended to secure availability, especially during peak seasons and weekends.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Arvind Desai",
    position: "Tour Coordinator",
    feedback:
      "We rented an Urbania Tourist Bus from Vaishnavi Travels for a sightseeing trip around Pune. The bus was comfortable, the AC worked well, and the driver was punctual and helpful. Great experience!",
    rating: 5,
  },
  {
    name: "Mrs. Rekha Patil",
    position: "Family Trip Organizer",
    feedback:
      "Vaishnavi Travels provided excellent service with their Urbania Tourist Bus. Spacious interiors, smooth ride, and a very courteous driver made our family outing memorable. Highly recommend their services.",
    rating: 5,
    style: "style-2",
  }
];





























































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Tourist Bus on Rent in Pune",
  "image": "https://vaishnavitravel.com/assets/images/urbania-tourist-bus-pune.jpg",
  "description": "Book Urbania Tourist Bus on rent in Pune with Vaishnavi Travels. Available in 13 and 17 seater AC options for Pune local tours, outstation trips, family travel, and city sightseeing with driver.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.88",
    "ratingCount": "610"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4500",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/urbania-tourist-bus-on-rent-in-pune"
  }
};




  return (
    <div>

<Helmet>
  <title>Urbania Tourist Bus on Rent in Pune | 13 & 17 Seater AC Vans | Vaishnavi Travels</title>
  <meta
    name="description"
    content="Book Urbania Tourist Bus on rent in Pune with Vaishnavi Travels. Available in 13 and 17 seater AC options for Pune local tours, outstation trips, family travel, and city sightseeing with driver."
  />
  <meta
    name="keywords"
    content="Urbania Travel Bus Pune, Tourist Urbania Hire Pune, AC Urbania Tourist Van Pune, 13/17 Seater Tourist Urbania Pune, Pune Local Tour Urbania, Urbania for Outstation Tourism, City Sightseeing Urbania Pune, Pune Darshan Urbania Hire, Long Trip Urbania Bus Pune, Family Tour Urbania Rental, Online Tourist Urbania Pune, Weekend Tourist Urbania Pune, Premium Tourist Urbania Hire"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/35.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Urbaniatouristbusonrentinpune;